import App from "@/App";
import DashboardPage from "@/pages/DashboardPage";
import LoginPage from "@/pages/LoginPage";
import MerchantsPage from "@/pages/merchants/MerchantsPage";
import NotFound from "@/pages/NotFoundPage";
import ManageSecretKeysPage from "@/pages/payment-channels/ManageSecretKeysPage";
import PaymentChannelListsPage from "@/pages/payment-channels/PlatformChannelListsPage";
import RegisterPage from "@/pages/RegisterPage";
import ApiKeysPage from "@/pages/settings/ApiKeysPage";
import CurrencyPage from "@/pages/settings/CurrencyPage";
import ExchangeRatePage from "@/pages/settings/ExchangeRatePage";
import UserProfilePage from "@/pages/settings/UserProfilePage";
import ReportPage from "@/pages/transactions/ReportPage";
import ViewLogsPage from "@/pages/transactions/ViewLogsPage";
import { createBrowserRouter } from "react-router";
import { ProtectedRoute } from "./protected-route";
import { PublicRoute } from "./public-route";

const router = createBrowserRouter([
  // Public routes (accessible when not authenticated)
  {
    element: <PublicRoute />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
    ],
  },

  // Protected routes (require authentication)
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <App />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "merchants", element: <MerchantsPage /> },
          { path: "transaction-logs", element: <ViewLogsPage /> },
          { path: "transaction-report", element: <ReportPage /> },
          { path: "payment-channels", element: <PaymentChannelListsPage /> },
          { path: "manage-secret-keys", element: <ManageSecretKeysPage /> },
          { path: "exchange-rate", element: <ExchangeRatePage /> },
          { path: "currency", element: <CurrencyPage /> },
          { path: "profile", element: <UserProfilePage /> },
          { path: "api-keys", element: <ApiKeysPage /> },
        ],
      },
    ],
  },

  // 404 handler (catch-all route)
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
